import { get, put, post } from 'redux/shelf/api';
import { success } from 'redux/shelf/actions';
import { createReducer } from 'redux/shelf/reducer';
import { field } from 'redux/shelf';
import session from 'lib/session';

export const actions = {
  setVersion: put`settings/frontend/mjs_version`(),
  getConfig: get`settings/${session.getMerchant}/frontend`(field('config')),
  updateConfig: put`settings/${session.getMerchant}/frontend`(),

  getInjections: get`settings/${session.getMerchant}/assets/mjs-api-script`(
    field('injections')
  ),
  updateInjections:
    put`settings/${session.getMerchant}/assets/mjs-api-script`(),

  generateShopifyLink: put`shopify/upgrade-public-app`(field('sales')),
  getPlan: get`set-plan`(field('sales')),
  updatePlan: put`set-plan`(field('sales')),

  getPersonalization: get`settings/${session.getMerchant}/personalization`(
    field('personalization')
  ),
  updatePersonalization: put`settings/${session.getMerchant}/personalization`(
    field('personalization')
  ),

  getSearchConfig: get`settings/search-configuration`(
    field('searchConfiguration')
  ),
  updateSearchConfig: put`settings/search-configuration`(),
  getPushApiConfig: get`settings/push-api/status`(field('pushApiStatus')),
  enablePushApi: post`settings/push-api/enable`(),
  disablePushApi: post`settings/push-api/disable`(),
};

export const reducer = createReducer(actions, {
  [actions.enablePushApi]: (s) => ({
    ...s,
    pushApiStatus: {
      status: 'enabled',
    },
  }),
  [actions.disablePushApi]: (s) => ({
    ...s,
    pushApiStatus: {
      status: 'disabled',
    },
  }),
});
